{
  "it": {
    "filteredList": {
      "actions": {
        "showFilter": "Mostra filtri",
        "hideFilter": "Nascondi filtri"
      },
      "selected": "Filtri selezionati",
      "remove": "Rimuovi %{filter}",
      "more": "+%{count} altri",
      "groups": {
        "ship": "Nave",
        "capacity": "Capacità e dimensioni",
        "weapons": "Armi",
        "price": "Prezzo",
        "ownership": "Proprietà"
      }
    }
  }
}
